import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

var helpers = createMultiStyleConfigHelpers(["container", "thumb", "track"]);
var Menu = helpers.defineMultiStyleConfig({
    // define the part you're going to style
    baseStyle: {
        container: {
            // ...
            _disabled: {
                ".chakra-switch__thumb": {
                    border: "1px",
                    borderStyle: "solid",
                    borderColor: "neutrals.400",
                },
            },
        },
        thumb: {
            height: "20px",
            width: "20px",
            bg: "neutrals.white",
            position: "absolute",
            top: "0",
            left: "-2px",
            border: "1px",
            borderStyle: "solid",
            borderColor: "neutrals.600",
            _checked: {
                position: "absolute",
                top: "0",
                left: "8px",
            },
        },
        track: {
            bg: "neutrals.800",
            border: "1px",
            borderStyle: "solid",
            borderColor: "neutrals.600",
            _checked: {
                bg: "success.800",
                border: "1px",
                borderStyle: "solid",
                borderColor: "neutrals.600",
            },
            _disabled: {
                bg: "neutrals.500",
                border: "1px",
                borderStyle: "solid",
                borderColor: "neutrals.400",
                _checked: {
                    bg: "neutrals.200",
                    border: "1px",
                    borderStyle: "solid",
                    borderColor: "neutrals.400",
                },
            },
        },
    },
    sizes: {
        sm: {
            container: {},
            thumb: {
                width: "16px",
                height: "16px",
            },
            track: {
                width: "28px",
                height: "10px",
            },
        },
        lg: {
            container: {},
            thumb: {
                width: "20px",
                height: "20px",
                _checked: {
                    position: "absolute",
                    top: "0",
                    left: "-1px",
                },
            },
            track: {
                width: "32px",
                height: "14px",
            },
        },
    },
    defaultProps: {
        size: "lg",
    },
});
var switchTheme = Menu;

export { switchTheme };
//# sourceMappingURL=switch.js.map
